import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import ApiService from '../../../services/apiService';
import { AiOutlinePrinter } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import 'ag-grid-community/styles/ag-grid.css';
import { AgGridReact } from 'ag-grid-react';
import { FaRegEye } from 'react-icons/fa6';
import moment from 'moment';
import { GrEdit } from 'react-icons/gr';
import { IoAddSharp } from 'react-icons/io5';
import Pagination from '../../pagination/pagination';
import { useDispatch } from 'react-redux';
import { clearRows } from '../../../../Redux/actions/rowActions';
const PurchaseOrderGridK = () => {
  const REPORT_URL = process.env.REACT_APP_REPORTS_URL;

  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const [formData, setFormData] = useState([]);
  const dispatch = useDispatch();
  const [pcPagination, setPCPagination] = useState();
  const [permissions, setPermissions] = useState([]);
  const [selectedtem, setSelectedItem] = useState(null);
  const apiService = new ApiService();
  let navigate = useNavigate();
  useEffect(() => {
    getItems();
    getPO();
    const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
    const permissions = storedPermissions?.filter((acc) => acc?.formName === 'Purchase Order');
    setPermissions(permissions[0]);
  }, []);
  const dateFormatter = (params) => {
    if (!params.value) return '';
    const date = moment(params.value);
    return date.isValid() ? date.format('DD-MMM-YYYY') : '';
  };
  const dateComparator = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
  };
  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      const res = await apiService.getApiParamater('GET_PO', `?${params.toString()}`);
      setPagination(res?.data?.paginationData);
      const sortedData = res?.data?.result?.slice().sort((a, b) => {
        const idA = parseInt(a?.pOrderNo?.split('-')[2]);
        const idB = parseInt(b?.pOrderNo?.split('-')[2]);
        return idB - idA;
      });
      setRowData(sortedData || []);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };
  const getPO = async (newPageNo = pcPagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append('Status', 1);
      const res = await apiService.getApiParamater('GET_PC', `?${params.toString()}`);
      setPCPagination(res?.data?.paginationData);
      const data = res?.data?.result || [];

      const transformedData = [];
      const groupedData = data?.reduce((acc, item) => {
        item?.priceComparisonDetails?.forEach((detail) => {
          for (let i = 1; i <= 6; i++) {
            const supplier = detail[`supp${i}`];
            const supplierId = detail[`suppId${i}`];
            const selected = detail[`selected${i}`];
            if (supplier && selected === 1) {
              const requisitionNo = item?.requisitionNo;
              const pcNo = item?.pcNo;
              const pcDate = item?.pcDate;
              const vendorKey = `${requisitionNo}-${supplier.trim()}`;
              if (!acc[vendorKey]) {
                acc[vendorKey] = {
                  vendorName: supplier.trim(),
                  supplierId: supplierId,
                  requisitionNo: requisitionNo,
                  pcDate: pcDate,
                  pcNo: pcNo,
                  paymentTerms: detail[`paymentTerms${i}`] || '',
                  items: [],
                };
              }

              if (!acc[vendorKey].items?.some((existingItem) => existingItem?.itemCode === detail?.itemCode)) {
                acc[vendorKey].items?.push({
                  itemCode: detail?.itemCode,
                  itemDescription: detail?.itemDescription,
                  qty: detail?.qty,
                  price: detail[`price${i}`] || 0,
                  amount: (detail[`price${i}`] || 0) * detail?.qty,
                  ref: detail[`ref${i}`] || '',
                  remarks: detail[`remarks${i}`] || '',
                  uom: detail?.uom,
                });
              }
            }
          }
        });
        return acc;
      }, {});
      for (const key in groupedData) {
        transformedData?.push(groupedData[key]);
      }
      debugger
      const responses = await Promise.all(
        transformedData.map((item) => {
          const params = new URLSearchParams();
          params.append("RequisitionNo", item.requisitionNo);

          return apiService.getApiParamater(
            "PO_REQ_LIST",
            `?${params.toString()}`
          );
        })
      );

      const allPoList = responses.flatMap(
        (res) => res?.data?.result || []
      );

      const filteredPoList = transformedData.filter(
        (po) =>
          !allPoList.some(
            (podata) =>
              podata.requisitionNo === po.requisitionNo &&
              podata.vendorName === po.vendorName
          )
      );

      setLoading(false);
      setFormData(filteredPoList);
    } catch (error) {
      setLoading(false);
      console.error('Error fetching items:', error);
    }
  };
  const handlePO = (data) => {
    dispatch(clearRows());
    navigate('/Inventory/PurchaseOrder/Create/Two', { state: data });
  };
  const handlePrint = () => {
    if (selectedRow) {
      // dispatch(clearRows());
      const token = localStorage.getItem('Token');
      const DB = localStorage.getItem('DataBase');
      if (!token) {
        alert('Auth token is missing! Unable to proceed.');
        return;
      }
      const popupWidth = 1000;
      const popupHeight = 600;
      const popupLeft = (window.screen.width - popupWidth) / 2;
      const popupTop = (window.screen.height - popupHeight) / 2;
      const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

      if (popup) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = REPORT_URL;
        form.target = 'ReportPopup';

        const inputs = [
          { name: 'authToken', value: token },
          { name: '_db', value: DB },
          { name: 'reportName', value: 'POrder' },
          { name: 'voucherNo', value: selectedRow?.pOrderNo },
        ];

        inputs.forEach(({ name, value }) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
      // navigate(`/Inventory/Purchase/Order/${selectedRow?.recordId}`, { state: selectedRow })
    }
  };
  const handleEdit = (clickedRowData) => {
    let eye = false;
    if (clickedRowData?.pOrderNo) {
      const updatedData = { ...clickedRowData, eye: eye };
      if (updatedData?.status === 1) {
        let eye = true;
        const updatedData = { ...clickedRowData, eye: eye };
        dispatch(clearRows());
        navigate(`/Inventory/Purchase/${updatedData?.pOrderNo}`, { state: updatedData });
      } else {
        dispatch(clearRows());
        navigate(`/Inventory/Purchase/${updatedData?.pOrderNo}`, { state: updatedData });
      }
    } else {
      const updatedData = { ...selectedtem, eye: eye };
      if (updatedData?.status === 1) {
        let eye = true;
        const updatedData = { ...selectedtem, eye: eye };
        dispatch(clearRows());
        navigate(`/Inventory/Purchase/${updatedData?.pOrderNo}`, { state: updatedData });
      } else {
        dispatch(clearRows());
        navigate(`/Inventory/Purchase/${updatedData?.pOrderNo}`, { state: updatedData });
      }
    }
  };
  const handleEye = (clickedRowData) => {
    if (clickedRowData?.pOrderNo) {
      let eye = true;
      const updatedData = { ...clickedRowData, eye: eye };
      dispatch(clearRows());

      navigate(`/Inventory/PurchaseOrder/${updatedData.pOrderNo}`, { state: updatedData });
    } else {
      let eye = true;
      const updatedData = { ...selectedRow, eye: eye };
      dispatch(clearRows());
      navigate(`/Inventory/PurchaseOrder/${updatedData.pOrderNo}`, { state: updatedData });
    }
  };
  const Comparison = [
    { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
    { headerName: 'Po No', field: 'pOrderNo', suppressMovable: true, width: 210 },
    {
      headerName: 'Req No',
      field: 'requisitionNo',
      suppressMovable: true,
      width: 210,
    },
    {
      headerName: 'Date',
      field: 'docDate',
      suppressMovable: true,
      width: 210,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
    },
    { headerName: 'Supplier ID', field: 'vendorId', suppressMovable: true, width: 180 },
    { headerName: 'Supplier Name', field: 'vendorName', suppressMovable: true, width: 210 },
    {
      headerName: 'Delivery Status',
      field: 'status',
      suppressMovable: true,
      width: 180,
      cellRenderer: function (params) {
        if (params.value === 0 || params.value === null) {
          return <div>Pending</div>;
        } else if (params.value === 1 || params.value === null) {
          return <div>Approved</div>;
        } else if (params.value === 5 || params.value === null) {
          return <div>Hold</div>;
        } else if (params.value === 2 || params.value === null) {
          return <div>Rejected</div>;
        } else {
          return params.value;
        }
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      suppressMovable: true,
      width: 180,
      cellRenderer: function (params) {
        if (params.value === 0 || params.value === null) {
          return <button class="btn pend ">Pending</button>;
        } else if (params.value === 1 || params.value === null) {
          return <button class="btn aproved">Approved</button>;
        } else if (params.value === 5 || params.value === null) {
          return <button class="btn hold">Hold</button>;
        } else if (params.value === 2 || params.value === null) {
          return <button class="btn reject">Rejected</button>;
        } else if (params.value === 3 || params.value === null) {
          return <button class="btn aproved">Approved</button>;
        } else {
          return params.value;
        }
      },
    },
    {
      headerName: 'Approval date',
      field: 'approvalDate',
      suppressMovable: true,
      width: 160,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
    },
  ];
  const Requisition = [
    { headerName: 'Req No', field: 'requisitionNo', suppressMovable: true, width: 335 },
    {
      headerName: 'Date',
      field: 'pcDate',
      suppressMovable: true,
      width: 330,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
    },
    { headerName: 'Supplier ID', field: 'supplierId', suppressMovable: true, width: 350 },
    { headerName: 'Supplier Name', field: 'vendorName', suppressMovable: true, width: 350 },
    {
      headerName: 'Active',
      field: 'id',
      cellRenderer: BtnCellRenderer,
      cellRendererParams: {
        permissions: permissions,
        handlePO: handlePO,
      },
    },
  ];
  const frameworkComponents = {
    btnCellRenderer: BtnCellRenderer,
  };
  const handlenew = () => {
    dispatch(clearRows());
    navigate('/Inventory/PurchaseOrder/Create/Two');
  };
  const onCellClicked = (event) => {
    if (event.colDef.field === 'pOrderNo') {
      const clickedRowData = event.data;
      dispatch(clearRows());
      handleEye(clickedRowData);
    }
  };
  const onSelectionChanged = async (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
    const params = new URLSearchParams();
    params.append('DocNo', selectedRows[0]?.pOrderNo);
    params.append('DocumentType', 'PO');
    try {
      const res = await apiService.getApiParamater('GET_EDITABLE_DOC', `?${params.toString()}`);
      const statuses = res?.data?.result?.map((item) => item.status);
      const allAreZero = statuses.every((status) => status === 0);
      const anyIsFive = statuses?.some((status) => status === 2);
      if (allAreZero || anyIsFive) {
        setSelectedItem(selectedRows.length === 1 ? selectedRows[0] : null);
      } else {
        console.warn('No valid status to set the item.');
        setSelectedItem(null);
      }
    } catch (error) {
      setSelectedItem(null);
      console.error('Error fetching document status:', error);
    }
  };
  return (
    <div className="p-4">
      <div className="border-box2 p-3 justify-content-between d-flex align-items-center pb-2">
        <h4 className="col mainInvHead mb-0">Pending Purchase Order</h4>
        {permissions?.canAdd === true ? (
          <button className="mainbtn " type="submit" onClick={() => handlenew()}>
            <IoAddSharp color="#fff" className="center mt-1" /> <div>Add</div>
          </button>
        ) : (
          ''
        )}
      </div>
      <div className="gridshad">
        <div className="ag-theme-quartz" style={{ height: 220 }}>
          <AgGridReact
            getRowStyle={(params) => {
              if (params.node.rowIndex % 2 === 0) {
                return { background: '#F0EDF5' };
              } else {
                return { background: '#fff' };
              }
            }}
            rowData={formData}
            columnDefs={Requisition}
            frameworkComponents={{ frameworkComponents }}
          />
        </div>
        <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pcPagination} getItems={getPO} />
      </div>
      <div style={{ marginTop: '-1.25rem' }}>
        <div className="border-box2 p-3 justify-content-between mt-2 d-flex">
          <h5 className="col mainInvHead">Purchase Order</h5>
          <div className="d-flex justify-content-end gap-1">
            <div
              onClick={handleEye}
              className={`mainbtnGry flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
              style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
            >
              <FaRegEye color="#fff" className="center mt-1 mx-2" />
              <div className="center">View</div>
            </div>
            {permissions?.canUpdate === true ? (
              <div
                onClick={(selectedtem && selectedtem?.status === 0) || selectedtem?.status === 2 ? handleEdit : null}
                className={`mainbtnSecondary flex-end gap-2 ${!selectedtem || selectedtem?.status === 0 || selectedtem?.status === 2 ? '' : 'disabled'}`}
                style={{
                  cursor: (selectedtem && selectedtem?.status === 0) || selectedtem?.status === 2 ? 'pointer' : 'not-allowed',
                }}
              >
                <GrEdit color="#fff" className="center mt-1 " />
                <div className="center">Edit</div>
              </div>
            ) : (
              ''
            )}
            <div
              onClick={handlePrint}
              className={`mainbtnRed flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
              style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
            >
              <AiOutlinePrinter color="#fff" className="center mt-1 mx-2" />
              <div className="center">Print</div>
            </div>
          </div>
        </div>
        <div className="gridshad">
          <div className="ag-theme-quartz" style={{ height: 'calc(100vh - 380px)', minHeight: 440 }}>
            <AgGridReact
              getRowStyle={(params) => {
                if (params.node.rowIndex % 2 === 0) {
                  return { background: '#F0EDF5' };
                } else {
                  return { background: '#fff' };
                }
              }}
              rowData={rowData}
              enableFilter={true}
              floatingFilter={true}
              columnDefs={Comparison}
              onCellClicked={onCellClicked}
              onSelectionChanged={onSelectionChanged}
            />
          </div>
          <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
        </div>
      </div>
    </div>
  );
};
class BtnCellRenderer extends Component {
  btnClickedHandler() {
    const { value, clicked } = this.props;
    clicked(value);
  }
  constructor(props) {
    super(props);
    this.btnEditClickedHandler = this.btnEditClickedHandler.bind(this);
  }

  btnEditClickedHandler() {
    const { data, handlePO } = this.props;
    handlePO(data);
  }
  render() {
    const { permissions } = this.props;

    return (
      <div>
        {permissions?.canAdd === true ? (
          <button onClick={this.btnEditClickedHandler} className="gridbtn p-0">
            Create PO
          </button>
        ) : (
          <button style={{ cursor: 'not-allowed' }} className="gridbtn p-0">
            Create PO
          </button>
        )}
      </div>
    );
  }
}
export default PurchaseOrderGridK;
